import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import UserProductBox from '../components/userProductBox';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { METHODTYPE } from '../components/constants';
import Swal from 'sweetalert2'
import { Accordion } from 'react-bootstrap';
import { hasRoles } from '../common/auth0Common';

const Products = () => {
  const { companyName } = useParams();
  const { logout } = useAuth0();
  //const location = useLocation();
  // let companyName = decodeURIComponent(location.pathname.split('/').pop());

  //const queryParams = new URLSearchParams(location.search);
  //let queryCompanyId = queryParams.get('companyId') || '-1';
  //queryCompanyId = isNaN(parseInt(queryCompanyId)) ? -1 : queryCompanyId;

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Alle");
  const [selectedCompany, setSelectedCompany] = useState(companyName ? decodeURIComponent(companyName) : "Alle");
  const location = useLocation();

  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const history = useHistory();
  const { isAuthenticated, loginWithRedirect,getAccessTokenSilently, user } = useAuth0();

  // Mapping für Kategorie-IDs zu Namen
  const categoryMap = {
    1: "Restaurantbesuch",
    2: "Produkt",
    3: "Rabattgutschein"
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  useEffect(() => {
    filterProducts();
  }, [products, selectedCategory, selectedCompany]);

  const getAllProducts = async () => {
    try {
      //const token = await getAccessTokenSilently();

      const response = await fetch(
        //`${serverUrl}/api/products?companyId=${queryCompanyId}`,
        `${serverUrl}/api/products`,
        {
          headers: {
            "Content-Type": "application/json",
            //   //Authorization: `Bearer ${token}`,
          },
        },
      );

      const responseData = await response.json();

      // Mapping der Kategorienamen anhand der categoryId
      const mappedProducts = responseData.map(product => ({
        ...product,
        category: categoryMap[product.categoryId] || "Unbekannt"
      }));

      setProducts(mappedProducts);

      // Extrahiere die Kategorien aus den gemappten Produkten
      const productCategories = ["Alle", ...new Set(mappedProducts.map(product => product.category))];
      setCategories(productCategories);
      const productCompanies = ["Alle", ...new Set(mappedProducts.map(product => product.companyName))];
      setCompanies(productCompanies);
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  };

  const filterProducts = () => {
    let filteredProducts = products;

    if (selectedCategory === "Alle") {
      filteredProducts = products;
    } else {
      const filtered = products.filter(product => product.category === selectedCategory);
      filteredProducts = filtered;
    }

    if (selectedCompany === "Alle") {
      //Do nothing
    } else {
      const filtered = filteredProducts.filter(product => product.companyName === selectedCompany);
      filteredProducts = filtered;
    }
    setFilteredProducts(filteredProducts);
  };

  const addToDeserves = async (product) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(
        `${serverUrl}/api/deserves/${product.idProduct}`,
        {
          method: METHODTYPE.POST,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response.json();
      if (responseData.isSuccessful === true) {
        swalWithBootstrapButtons.fire({
          title: "Hinzugefügt!",
          text: responseData.message,
          icon: "success"
        });
      } else {
        swalWithBootstrapButtons.fire({
          title: "Oops...",
          text: responseData.message,
          icon: "error"
        });
      }


      history.push("/deserves");
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-outline-warning",
      cancelButton: "btn btn-outline-warning"
    },
    buttonsStyling: false
  });

  const isDeserverOrOpenToAll= () =>
  {
    return (hasRoles(user, ["deserver"]) || !isAuthenticated);
  }

  const handleProtectedAction = async () => {
    if (!isAuthenticated) {
      // If not logged in, redirect to Auth0
      // We pass the current path so Auth0 knows where to come back to
      loginWithRedirect({
        appState: { returnTo: location.pathname },
      });
      return;
    }
  };

  return (
    <div className="container">
      <h1>Produkte</h1>

      {isDeserverOrOpenToAll() && (
        <p>
          Hier findest Du alle aktuell verfügbaren Angebote. Wähle Deine Favoriten und starte mit dem deserven!
        </p>
      )}

      {hasRoles(user, ["company"]) && (
        <p>
          Hier findest Du alle aktuell verfügbaren Angebote. Darunter findest Du auch die Angebote Deiner Konkurrenz.
        </p>
      )}
      {hasRoles(user, ["admin"]) && (
        <p>
          Hier findest Du alle aktuell verfügbaren Angebote.
        </p>
      )}

      <Accordion defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>So funktioniert's</Accordion.Header>
          {isDeserverOrOpenToAll() && (
            <Accordion.Body>
              <strong>Stöbere durch die verfügbaren Angebote</strong> und wähle die aus, die Dich interessieren.<br /> <br />
              <strong>Zu jedem Angebot findest Du:</strong><br />
              • Eine detaillierte Beschreibung<br />
              • Den Link zur Homepage<br />
              • Die Anzahl der Likes, die Du sammeln musst<br />
              • Die Verfügbarkeit<br />
              • Den Zeitraum, um die Likes zu sammeln<br />
              • Das Ablaufdatum des Angebots<br /><br />
              <strong>Wenn Dich ein Angebot anspricht und Du es deserven möchtest, klicke einfach auf "deserven"!</strong>
            </Accordion.Body>
          )}
          {hasRoles(user, ["company"]) && (
            <Accordion.Body>
              <strong>Stöbere durch die verfügbaren Angebote</strong> und gewinne einen Eindruck, welche Angebote bereits bestehen.<br /> <br />
              <strong>Zu jedem Angebot findest Du:</strong><br />
              • Eine detaillierte Beschreibung<br />
              • Den Link zur Homepage<br />
              • Die Anzahl der Likes, die Du sammeln musst<br />
              • Die Verfügbarkeit<br />
              • Den Zeitraum, um die Likes zu sammeln<br />
              • Das Ablaufdatum des Angebots<br /><br />
            </Accordion.Body>
          )}
          {hasRoles(user, ["admin"]) && (
            <Accordion.Body>
              <strong>Stöbere durch die verfügbaren Angebote</strong> und gewinne einen Eindruck, welche Angebote bereits bestehen.<br /> <br />
              <strong>Zu jedem Angebot findest Du:</strong><br />
              • Eine detaillierte Beschreibung<br />
              • Den Link zur Homepage<br />
              • Die Anzahl der Likes, die Du sammeln musst<br />
              • Die Verfügbarkeit<br />
              • Den Zeitraum, um die Likes zu sammeln<br />
              • Das Ablaufdatum des Angebots<br /><br />
            </Accordion.Body>
          )}
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Produkte</Accordion.Header>
          <Accordion.Body>
            <div className="form-group">
              <div className="row">
                <div className="col-6">
                  <label htmlFor="category-select">Kategorie auswählen:</label>
                  <select
                    id="category-select"
                    className="form-control"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    {categories.map((category, index) => (
                      <option key={index} value={category}>{category}</option>
                    ))}
                  </select>
                </div>

                <div className="col-6">
                  <label htmlFor="category-select">Unternehmen auswählen:</label>
                  <select
                    id="company-select"
                    className="form-control"
                    value={selectedCompany}
                    onChange={(e) => setSelectedCompany(e.target.value)}
                  >
                    {companies.map((company, index) => (
                      <option key={index} value={company}>{company}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <hr />
            <br />
            <div className="row">
              {filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                  <UserProductBox
                    key={product.idProduct}
                    product={product}
                    button={
                      isDeserverOrOpenToAll() && <button
                        id={product.idProduct}
                        className="btn btn-outline-warning"
                        onClick={() => {
                        handleProtectedAction();
                          if (isAuthenticated && !user?.email_verified) {
                            swalWithBootstrapButtons.fire({
                              icon: "warning",
                              title: "E-Mail nicht verifiziert / neuer Login erforderlich",
                              text: "Du kannst nicht deserven, solange Du Deine Emailadresse nicht verifiziert hast. Nachdem Du die Emailadresse verifiziert hast, ist ein erneuter Login auf dieser Seite notwendig. Du wirst daher jetzt automatisch ausgeloggt.",
                              confirmButtonText: "OK",
                            }).then(() => {
                              logout({
                                returnTo: window.location.origin,
                              });
                            });
                            return;
                          }

                          if(isAuthenticated)
                          {
                          swalWithBootstrapButtons.fire({
                            title: "Möchtest Du das Produkt deserven?",
                            text: "",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Ja, deserven!",
                            cancelButtonText: "Nein, abbrechen!",
                            //reverseButtons: true
                          }).then((result) => {
                            if (!result.isConfirmed) return;
                            if (!product.alcohol){
                              addToDeserves(product);
                              return;
                            }
                            // 🍺 Alkohol → zweites Popup
                            swalWithBootstrapButtons.fire({
                              title: "Besondere Teilnahmebedingung",
                              text: "Um dieses Produkt deserven zu können, musst Du volljährig sein.",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonText: "Ja, ich bin 18+",
                              cancelButtonText: "Abbrechen",
                            }).then((ageResult) => {
                              if (ageResult.isConfirmed) {
                                addToDeserves(product);
                              }
                            });
                          });
                        }
                        }}>
                        {'deserven'}
                      </button>
                    }
                  />
                ))
              ) : (
                <p>Keine Ergebnisse gefunden.</p>
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Products;